import LinkUnlink from "@/assets/images/job-rating/link-unlink.svg";
import { Container, Typography } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";

export const JobRatingExpired = () => {
  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader />
        <Container className="flex flex-1 flex-col items-center pb-[338px] pt-[60px] text-center">
          <img src={LinkUnlink} alt="LinkUnlink" className="h-64 w-64" />
          <Typography variant="h2" className="mt-6">
            Rating Period Expired
          </Typography>
          <div className="mt-8 w-10/12 break-words">
            <Typography variant="paragraph">You&apos;ll no longer be able to rate your booking after 7 days.</Typography>
          </div>
        </Container>
        <GeneralFooter />
      </div>
    </div>
  );
};
